import './competitionPopup.css'

const state = {
  run: false,
  clickCounter: 0,
  mode: 'desktop',
  closeFunction: null
}

const handleFormSuccess = (event, popup, closeFunction) => {
  const closeTimer = setTimeout(closeFunction, 7000)
  popup.querySelectorAll('[data-action="wcp-close"]').forEach(elem => {
    elem.addEventListener('click', () => {
      clearTimeout(closeTimer)
    })
  })
  state.run = false

  if (window.ga !== undefined) {
    event.target.dataset.mode === 'registration'
      ? window.ga('send', 'event', 'Wishlist', 'Create an account', 'Create account from wishlist')
      : window.ga('send', 'event', 'Wishlist', 'Login to account', 'Login to account from wishlist')
  }
}

const createPopup = () => {
  const popup = document.createElement('div')
  popup.classList.add('wcp__container')
  popup.classList.add(`wcp__container--${state.mode}`)
  popup.innerHTML = `
  <account-form-component data-mode="registration">
    <div class="afc__form_wrapper wcp__form-wrapper">
      <div class="wcp__image">
        <img src="https://cdn.shopify.com/s/files/1/1568/8443/files/saveWish.jpg?v=1624948459&width=400"
             srcset="https://cdn.shopify.com/s/files/1/1568/8443/files/saveWish.jpg?v=1624948459&width=800 2x, https://cdn.shopify.com/s/files/1/1568/8443/files/saveWish.jpg?v=1624948459&width=1200 3x"
             alt=""/>
      </div>
      <p class="wcp__text-wrapper">
        <span class="afc__hidden--login">Create</span><span class="afc__hidden--registration">Login to</span> your account to <b>access your wishlist<br/>
        from any device</b>, enjoy exclusive offers,<br/>
        faster checkout, order tracking, and more!
      </p>
        <div data-form-error class="wcp__form-error" hidden></div>
        <form class="wcp__form" action="/account">
          <input type="text" name="customer[first_name]" required placeholder="NAME">
          <input type="email" name="customer[email]" required placeholder="EMAIL">
          <input type="password" name="customer[password]" required placeholder="PASSWORD">
          <button type="submit">
            <span class="afc__hidden--login">CREATE ACCOUNT</span>
            <span class="afc__hidden--registration">LOGIN</span>
            <i class="icon--loader"></i>
          </button>
        </form>
        
        <p class="wcp__terms afc__hidden--login">By clicking CREATE, you agree to ElephantStock <a href="/pages/terms-and-conditions" class="copyright_link">Terms of Service</a> and <a href="/pages/privacy-policy" class="copyright_link">Privacy Policy</a>.</p>
        <div class="wcp__sign-sting d:block fw:700 afc__hidden--login">Already have an account? <span data-mode-changer class="login_link">Sign in</span></div>
        <div class="wcp__sign-sting d:block fw:700 afc__hidden--registration">Don't have an account? <span data-mode-changer class="login_link">Registration</span></div>
        <span class="wcp__close-sting" data-action="wcp-close">No thanks</span>
    </div>
    
    <div class="afc__success_wrapper wcp__success-wrapper">
      <p class="wcp__success-title">Thank You</p>
      <p class="wcp__success-text">
        Now you can save your wishlist, track orders,<br/>
        and enjoy exclusive offers!
      </p>
    </div>
    <p class="afc__error_wrapper wcp__error-wrapper ml:auto mr:auto">
      Sorry that something went wrong.<br>
      Please try again later.
    </p>
    <span class="wcp__close-x" data-action="wcp-close">
      <s-svg data-icon="icon--close-x" style="aspect-ratio: 17.4 / 17.4;"></s-svg>
    </span>
  </account-form-component>
  `
  return popup
}

const bindPopupToElement = (popup, element) => {
  const isHomePage = document.body.classList.contains('template-index')
  let popupOffsetLeft
  let popupOffsetRight
  if (isHomePage) {
    popup.style.setProperty('--tr-pos-top', '-4px')
    popup.style.setProperty('--tr-pos-bottom', 'auto')
    popupOffsetLeft = 200
    popupOffsetRight = 200
  } else {
    popup.style.setProperty('--tr-pos-top', '-4px')
    popup.style.setProperty('--tr-pos-bottom', 'auto')
    popupOffsetLeft = 370
    popupOffsetRight = 30
  }

  function setPosition () {
    const elRect = element.getBoundingClientRect()
    const halfElWidth = element.offsetWidth / 2

    if (elRect.right - (popupOffsetLeft + halfElWidth) < 10) {
      popup.style.left = '10px'
      popup.style.right = 'auto'
      popup.style.setProperty('--tr-pos-left', elRect.right - (10 + halfElWidth) + 'px')
      popup.style.setProperty('--tr-pos-right', 'auto')
      popup.style.setProperty('--tr-transl', '-50%')
    } else if (document.body.clientWidth - elRect.right < popupOffsetRight - halfElWidth) {
      popup.style.left = 'auto'
      popup.style.right = '10px'
      popup.style.setProperty('--tr-pos-left', 'auto')
      popup.style.setProperty('--tr-pos-right', document.body.clientWidth - elRect.right - (10 - halfElWidth) + 'px')
      popup.style.setProperty('--tr-transl', '50%')
    } else {
      popup.style.left = elRect.right - (popupOffsetLeft + halfElWidth) + 'px'
      popup.style.right = 'auto'
      popup.style.setProperty('--tr-pos-left', 'auto')
      popup.style.setProperty('--tr-pos-right', popupOffsetRight + 'px')
      popup.style.setProperty('--tr-transl', '50%')
    }

    // popup.style.top = isHomePage
    //   ? elRect.bottom + 10 + 'px'
    //   : elRect.top - 10 - popup.offsetHeight + 'px'

    popup.style.top = elRect.bottom + 10 + 'px'
  }
  setPosition()
  return setPosition
}

const showPopup = (target) => {
  if (!state.run || target.parentElement.matches('.alg__result-item_zoom_buttons')) {
    return false
  }

  if (++state.clickCounter < 3) {
    return false
  }
  state.clickCounter = 0

  state.closeFunction && state.closeFunction()

  const isFixed = !target.classList.contains('product__wishlist-button') || window.innerWidth < 1024
  const popup = createPopup()

  const container = isFixed
    ? document.body
    : target.parentElement

  container.classList.add('wcp__show-popup')
  container.append(popup)

  let closeFunction

  if (isFixed && window.innerWidth >= 1024) {
    const positionPopup = bindPopupToElement(popup, target.firstElementChild)
    window.addEventListener('scroll', positionPopup)
    window.addEventListener('resize', positionPopup)

    closeFunction = () => {
      window.removeEventListener('scroll', positionPopup)
      window.removeEventListener('resize', positionPopup)
      popup.remove()
      container.classList.remove('wcp__show-popup')
    }

    popup.querySelectorAll('[data-action="wcp-close"]').forEach(elem => {
      elem.addEventListener('click', event => {
        event.preventDefault()
        closeFunction()
      })
    })
  } else if (window.innerWidth < 1024) {
    const overlay = document.querySelector('.main-overlay')
    overlay.style.zIndex = 660
    overlay.setAttribute('aria-hidden', 'false')

    closeFunction = (event) => {
      event && event.preventDefault()
      overlay.setAttribute('aria-hidden', 'true')
      overlay.style.zIndex = ''
      overlay.removeEventListener('click', closeFunction)
      popup.remove()
      container.classList.remove('wcp__show-popup')
    }

    overlay.addEventListener('click', closeFunction)

    popup.querySelectorAll('[data-action="wcp-close"]').forEach(elem => {
      elem.addEventListener('click', closeFunction)
    })
  } else {
    closeFunction = () => {
      popup.remove()
      container.classList.remove('wcp__show-popup')
    }

    popup.querySelectorAll('[data-action="wcp-close"]').forEach(elem => {
      elem.addEventListener('click', (event) => {
        event.preventDefault()
        closeFunction()
      })
    })
  }

  popup.querySelector('account-form-component').addEventListener('success', event => {
    handleFormSuccess(event, popup, closeFunction)
  })

  state.closeFunction = closeFunction
}

const init = () => {
  if (window.customer.id) {
    return
  }

  state.run = true

  if (window.innerWidth < 1024) {
    state.mode = 'mobile'
  }
}

export const competitionPopup = {
  init,
  showPopup
}
